import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AngularFirestore } from '@angular/fire/firestore';
import { MatDialog } from '@angular/material/dialog';
import { Delivery, Iaddress, Users } from 'my-lib-sanfelici/my-lib-sanfelici';
import { UsersService, DeliveryService, StatiService } from 'my-lib-sanfelici';
import { NewMapsDialogViewComponent } from '../../new-maps/new-maps-dialog-view/new-maps-dialog-view.component';


@Component({
  selector: 'app-delivery-create',
  templateUrl: './delivery-create.component.html',
  styleUrls: ['./delivery-create.component.css']
})
export class DeliveryCreateComponent implements OnInit {
  id: string;

user: Users;
delivery: Delivery;
address: Iaddress;
  constructor(
    public dialog: MatDialog,
    private usersservice: UsersService,
    private deliveryservice: DeliveryService,
    private statiservice: StatiService,
    private route: ActivatedRoute,
    private db: AngularFirestore,
    private router: Router) { }
    openDialog(): void {
      const dialogRef = this.dialog.open(NewMapsDialogViewComponent, {

      });

      dialogRef.afterClosed().subscribe(result => {
        console.log('The dialog was closed');
        console.log(result);
        if (result) {
          this.address = result;
          console.log(this.address);
          this.delivery.address = this.address;

        }
      });
    }


    onSubmit() {
      this.user.delivery = this.delivery;
      this.usersservice.update(this.user)
      .then(() => {
        this.router.navigate(['/myuser',  'delivery', 'details', this.id]);
      });
       }

  ngOnInit() {
    this.id = this.route.snapshot.params.id;
    if(this.delivery){

    } else {
      this.delivery = {
        nominativo: null
      };
    }


    this.usersservice.details(this.id).subscribe(u => this.user = u);
  }

}
